"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getScrollParent = getScrollParent;
exports.isScrollable = isScrollable;
exports.isScrolling = isScrolling;
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
function isScrolling(overflowStyle) {
  return overflowStyle.indexOf('scroll') > -1 || overflowStyle.indexOf('auto') > -1;
}
function isScrollable(element) {
  var result = false;
  if (element) {
    var styles = getComputedStyle(element);
    result = /(auto|scroll)/.test(styles.overflow + styles.overflowX + styles.overflowY);
  }
  return result;
}
function getParentWith(_ref) {
  var withCondition = _ref.withCondition,
    element = _ref.element,
    container = _ref.container;
  if (!element || element === container) {
    return container;
  }
  return withCondition(element) ? element : getParentWith({
    withCondition: withCondition,
    element: element.parentElement,
    container: container
  });
}
function getScrollParent(element) {
  if (!(element instanceof HTMLElement) && !(0, _isNil["default"])(element)) {
    return getParentWith(element);
  }
  var result;
  if (!element || element === document.body) {
    result = document.body;
  } else {
    result = isScrollable(element.parentElement) ? element.parentElement : getScrollParent(element.parentElement);
  }
  return result;
}
var _default = exports["default"] = getScrollParent;